<template>
    <div class="flex gap-2 items-center">
        <tag
            class="text-white shadow-sm text-sm"
            value="In Cart"
            icon="pi pi-check"
            rounded
            v-if="inCart(tour.id + '')"
        />

        <tag
            class="text-white shadow-sm text-sm"
            value="Private"
            icon="pi pi-users"
            v-if="tour.private_tour"
        />
    </div>
</template>

<script setup lang="ts">
import useCart from "@/Hook/useCart";
import { Tour } from "@/types";
import { Tag } from "primevue";

defineProps<{
    tour: Tour;
}>();

const { inCart } = useCart();
</script>
